module.exports = __webpack_public_path__ + "img/luna gibosa creciente.8e1997ae.svg";